export const EmployeeTypeEnum = {
  REGULAR: "REGULAR",
  CONSULTANT: "CONSULTANT",
  IVYCLINIC: "IVYCLINIC",
  SQELABS: "SQELABS",
};
